import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@welldev-group/rcl-tooltip';
import { EmphasisTag } from '@welldev-group/react-comp-lib';
import Icon from '@welldev-group/rcl-icon';
import { NONE_FORM_OF_PAYMENT } from '../IBE/lib/helpers/fop_options';
import './style.scss';

const InstantTicketWrapper = ({ fop, size }) => {
  const isNoneFop = fop?.type === NONE_FORM_OF_PAYMENT;

  const emphasisTagColor = isNoneFop ? 'default' : 'inverse';
  const emphasisTagType = isNoneFop ? null : 'warning';
  const tooltipContent = isNoneFop
    ? I18n.t('ibe.payment.instant_ticket_warning')
    : I18n.t('components.instant_ticket.description');

  return (
    <Tooltip
      className="instant-ticket-wrapper"
      content={tooltipContent}
      type="inverse"
      position="bottom-right"
      showArrow={false}
    >
      <EmphasisTag
        text={I18n.t('components.instant_ticket.tag_name')}
        size={size}
        icon={<Icon name="neutralOutline" size="tiny" />}
        type={emphasisTagType}
        iconColor={emphasisTagColor}
      />
    </Tooltip>
  );
};

InstantTicketWrapper.defaultProps = {
  size: 'small',
};

InstantTicketWrapper.propTypes = {
  fop: PropTypes.shape({ type: PropTypes.string }).isRequired,
  size: PropTypes.string,
};

export default InstantTicketWrapper;
